var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"guest-name"},[(_vm.nameMissing)?[_c('span',{class:{'text-error' : _vm.highlightIfMissing, 'text-temporary' : !_vm.highlightIfMissing}},[_vm._v("Not supplied")])]:[_vm._v(" "+_vm._s(_vm.guest.lastName)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }